
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index0isZK8C2qbRGo789tuZ42KrEllXJ6XP_pagbC2s5DpQMeta } from "C:/Users/brend/GIT/kas-warranty/pages/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    meta: index0isZK8C2qbRGo789tuZ42KrEllXJ6XP_pagbC2s5DpQMeta || {},
    component: () => import("C:/Users/brend/GIT/kas-warranty/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: index0isZK8C2qbRGo789tuZ42KrEllXJ6XP_pagbC2s5DpQMeta || {},
    component: () => import("C:/Users/brend/GIT/kas-warranty/pages/index.vue")
  }
]